import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react"
import { Col, Container, Nav, NavItem, NavLink, Row, TabContent, TabPane } from "reactstrap"
import classnames from 'classnames';
import { object, string } from "yup";
import UserForm from "../../components/SettingsForm/UserForm";
import Form from "../../components/common/Form/From";
import CompanyForm from "../../components/SettingsForm/CompanyForm";
import { useDispatch } from "react-redux";
import { ApplicantActions, companyActions } from "../../actions";
import { useSelector } from "react-redux";
import { authActions } from "../../actions/auth.actions";
import * as Yup from "yup";
import styles from "./settings.module.scss"
import Loader from "../../components/common/Loader/Loader";
import ResourcePage from "../Resources/ResourcePage";
const SettingsPage = () => {
    const [activeTab, setActiveTab] = useState(1)
    const [submited, setSubmited] = useState(false);
    const [edited, setEdited] = useState(false)
    const [searchParams] = useSearchParams();
    const [initialValues, setInitialValues] = useState({
        country: "IN",
        phone: "",
        newPassword: "",
        oldPassword:"",
        cPassword: "",
        avtar: "",
        removeAvtar: ""

    });
    const applicantStatus = useSelector((state) => state.applicant.applicantStatus);
    const [companyInitialValues, setCompanyInitialValues] = useState({
        name: "",
        companyLogo: "",
        domain: "",
        address: "",
        companygst: "",
        cLogo: "",
        navigation: [{
            label: "",
            link: ""
        }],
        pageColor: "",
        banner: "",
        bannerTitle: "",
        bannerDetails: "",
        title: "",
        details: "",
        openingTitle: ""
    })

    const dispatch = useDispatch();

    const userProfile = useSelector((state) => state.authentication.userProfile);


    useEffect(() => {
        if (userProfile && userProfile?.favicon?.url) {
            let link = document.querySelector("link[rel~='icon']");
            if (!link) {
                link = document.createElement('link');
                link.rel = 'icon';
                document.getElementsByTagName('head')[0].appendChild(link);
            }
            link.href = userProfile?.favicon?.url;
        }

    }, [userProfile?.favicon]);

    const user = useSelector((state) => state.authentication.user);
    const SUPPORTED_FORMATS = ["image/jpeg", "image/jpg", "image/png"];
    const validationSchema = Yup.object({
        newPassword: Yup.string(),
        cPassword: Yup.string()
            .test('passwords-match', 'Passwords must match', function (value) {
                return this.parent.newPassword === value
            }),
        avtar: Yup
            .mixed()
            .test(
                "format",
                "Only the following formats are accepted: .jpeg, .jpg and .png",
                (value) => !value || (value && SUPPORTED_FORMATS.includes(value.type))
            ),
    })

    useEffect(() => {
        if (activeTab === '2') {
            dispatch(companyActions.getCompanySettings())
        } else {
            dispatch(authActions.getProfile())
        }
    }, [activeTab])

    useEffect(() => {
        if (userProfile) {
            setInitialValues({
                country: userProfile?.resource?.country ? userProfile?.resource?.country : "IN",
                phone: userProfile?.resource?.phone ? userProfile?.resource?.phone : "",
                newPassword: "",
                cPassword: "",
                avatar: "",
            })
        }
    }, [userProfile])




    useEffect(() => {
        if (searchParams.get("resourceId")) {
            toggle('3')
        }
        else {
            toggle('1')
        }
    }, [])


    const toggle = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab)
            setEdited(false)
        }
    }

    const renderForm = (errors, touched) => {
        return (
            <UserForm
                errors={errors}
                touched={touched}
                submited={submited}
                editedData={userProfile}
                edited={edited}
                setEdited={setEdited}
            />
        );
    };

    const handleSubmit = (values) => {
        setSubmited(true)
        dispatch(authActions.updateProfile(values)).then((res) => {
            if (res) {
                setSubmited(false);
                setEdited(false)
            }
        })
    }


    return (

        <Container>
            <Row>
                <Col md={12}>
                    <div>
                        <Nav tabs className={styles.tabPart}>
                            <NavItem>
                                <NavLink
                                    className={`${styles.tabLink} ${classnames({ active: activeTab === '1' })}`}
                                    onClick={() => { toggle('1'); }}
                                >
                                    User Info
                                </NavLink>
                            </NavItem>
                            {user && [1, 2].includes(user?.userRole) ?
                                <NavItem>
                                    <NavLink
                                        className={`${styles.tabLink} ${classnames({ active: activeTab === '2' })}`}
                                        onClick={() => { toggle('2'); }}
                                    >
                                        Company Profile
                                    </NavLink>
                                </NavItem> : ""

                            }
                            {user && user.userRole !== 4 ? (
                                <NavItem>
                                    <NavLink
                                        className={`${styles.tabLink} ${classnames({ active: activeTab === '3' })}`}
                                        onClick={() => { toggle('3'); }}
                                    >
                                        Team
                                    </NavLink>
                                </NavItem>) : ""}


                        </Nav>
                        <TabContent activeTab={activeTab}>
                            <TabPane tabId="1">
                                <Row>
                                    <Col sm="12">
                                        {userProfile ?
                                            <Form
                                                initialValues={initialValues}
                                                validationSchema={validationSchema}
                                                handleSubmit={handleSubmit}
                                                renderForm={renderForm}
                                            /> : <Loader color={"#5382ba"} />
                                        }

                                    </Col>
                                </Row>
                            </TabPane>
                            <TabPane tabId="2">
                                <Row>
                                    <Col sm="12">
                                        <CompanyForm edited={edited} />
                                    </Col>
                                </Row>
                            </TabPane>
                            <TabPane tabId="3">
                                <Row>
                                    <Col sm="12">
                                        {user.userRole !== 4 ?
                                            <div className="ResourcePart">
                                                <ResourcePage edited={edited} />
                                            </div> : ""
                                        }

                                    </Col>
                                </Row>
                            </TabPane>
                        </TabContent>
                    </div>
                </Col>
            </Row>
        </Container>
    )
}

export default SettingsPage;